import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GlobalSettings } from "../model/settings.model";
import { AuthenticationService } from "./auth.service";
import { ResourceService } from "./resource.service";
import { AddressModel } from "../model/address.model";

@Injectable({
    providedIn: 'root'
})
export class AddressService extends ResourceService<AddressModel> {

    constructor(
        http: HttpClient,
        settings: GlobalSettings,
        authenticationService: AuthenticationService) {
        super(http, "gateway/Public/Addresses", settings.processosUrl, authenticationService)
    }
}
